<div class="dialog-container">
  <h2 mat-dialog-title class="dialog-header">Company Representative</h2>

  <div mat-dialog-content>
    <p class="dialog-message">
      <strong>{{ data.memberName }}</strong>
    </p>
    <mat-form-field appearance="fill" class="cr-field">
      <mat-label>Company name</mat-label>
      <textarea matInput [(ngModel)]="value" rows="4"
                placeholder="Enter the company name"></textarea>
    </mat-form-field>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button type="button" class="nrg-error-raised-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button mat-raised-button color="primary" (click)="onSave()">
      <mat-icon>save</mat-icon>
      Save
    </button>
  </div>
</div>
